export const scoops = [
  {
    id: "sc-20260910-01",
    title: "连锁奶茶品牌被指「先涨价再打折」：同款饮品活动价高于日常价",
    category: "consumer",
    categoryLabel: "消费维权",
    excerpt:
      "多位门店员工匿名投稿，称部分新品在上线前一周悄悄调整了标价，随后再以「限时折扣」重新挂出，折后价格依然高于调整前。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20close%20up%20of%20a%20takeaway%20drink%20cup%20on%20a%20counter%20with%20soft%20amber%20light%20and%20blurred%20cafe%20background%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-tea-01&orientation=landscape",
    date: "2026-09-10",
    reads: 12840,
    status: "已核实",
    tags: ["价格套路", "连锁餐饮", "虚标折扣"],
    source: "多位门店员工匿名投稿",
    location: "华东地区",
    content: [
      {
        type: "p",
        text: "一份来自多家门店的排班与调价记录显示，某连锁奶茶品牌在部分新品正式上线前，先把菜单上的默认价格整体上调了两到三元，一周后再以「新品限时折扣」的名义对外宣传。折后价格看似优惠，实际仍高于调价前的日常定价。",
      },
      {
        type: "p",
        text: "投稿人提供的内部沟通记录提到，调价是「统一动作」，门店只负责执行，不参与定价。由于消费者普遍对「折扣」字样更敏感，折后的数字比原价更容易被接受，因此这一操作在过去两个促销周期中反复出现。",
      },
      { type: "h2", text: "折后价究竟差了多少" },
      {
        type: "p",
        text: "以其中一款畅销饮品为例，调价前菜单标价为 16 元，日常实际结算多为 14 元左右；调价后标价变为 19 元，限时折扣价 16 元。也就是说，活动期间的成交价比活动前还要高，而宣传口径却是「限时特惠」。",
      },
      {
        type: "quote",
        text: "我们不是不想说，是说了也没用，App 上的价格都是总部定的，门店改不了。",
      },
      { type: "h2", text: "投稿人主要反映了三点" },
      {
        type: "list",
        items: [
          "调价与上线时间高度重合，且集中在促销周期前一到两周。",
          "门店端与 App 端价格同步调整，但日常优惠券额度同时被下调。",
          "部分门店被要求口播「新品折扣」，无论顾客是否主动询问价格。",
        ],
      },
      {
        type: "p",
        text: "我们已就上述情况向品牌方发出问询，截至发稿未收到正式回应。核实小组仍在对不同城市的菜单快照进行比对，若后续口径发生变化会在本页更新说明。",
      },
      {
        type: "p",
        text: "需要提醒的是，不同城市、不同门店的定价存在差异，本文引用的价格仅为投稿人提供的样本，不代表所有门店的实际情况。",
      },
    ],
  },
  {
    id: "sc-20260908-02",
    title: "某直播团队被曝凌晨集中下单、白天整批退货",
    category: "industry",
    categoryLabel: "行业内幕",
    excerpt:
      "一名曾任临时运营的投稿人称，直播间为冲高当场在线人数与成交额，会组织「补量群」在特定时段集中下单，第二天再由同一批人走退款流程。",
    cover:
      "https://readdy.ai/api/search-image?query=dim%20home%20streaming%20setup%20with%20a%20switched%20off%20ring%20light%20and%20phone%20tripod%20in%20warm%20amber%20ambient%20light%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-live-02&orientation=landscape",
    date: "2026-09-08",
    reads: 20317,
    status: "核实中",
    tags: ["直播带货", "刷单", "成交数据"],
    source: "前临时运营人员投稿",
    location: "多地",
    content: [
      {
        type: "p",
        text: "投稿人曾在某直播团队担任临时运营，工作内容之一是维护若干个「补量群」。按照其描述，团队会在开播前约定好时间段，让群成员集中下单指定商品，以拉高当场成交额和在线人数。",
      },
      {
        type: "p",
        text: "这些订单大多在次日上午被批量发起退款。投稿人称，退货理由被统一定为「拍错了」或「不想要了」，以降低平台侧的风控关注。",
      },
      { type: "h2", text: "「补量」是怎么组织的" },
      {
        type: "list",
        items: [
          "开播前发布商品清单与下单时间，群成员按编号认领。",
          "下单后需截图回执，由运营统一登记。",
          "次日按登记名单走退款，部分商品以「仅退款」方式处理。",
        ],
      },
      {
        type: "quote",
        text: "对我们来说这就是一份兼职，下单有红包，退完就结束，没人真的在乎那个商品。",
      },
      { type: "h2", text: "核实进展" },
      {
        type: "p",
        text: "目前我们已拿到部分群聊截图与订单编号片段，正在与平台侧的公开数据做交叉比对。由于涉及团队归属和资金流向，尚需更多佐证，本条目暂标注为「核实中」。",
      },
      {
        type: "p",
        text: "如果你也参与过类似流程，欢迎通过投稿通道补充订单时间、金额区间等信息，我们会对所有来源做匿名处理。",
      },
    ],
  },
  {
    id: "sc-20260905-03",
    title: "写字楼物业连年上调能耗费，账单却没有分项明细",
    category: "society",
    categoryLabel: "社会热点",
    excerpt:
      "数家入驻企业投稿反映，物业收取的「公共能耗分摊」三年内上涨近七成，但只提供总额，不提供电表读数、分摊系数等可核对的分项数据。",
    cover:
      "https://readdy.ai/api/search-image?query=night%20view%20of%20a%20modern%20office%20building%20facade%20with%20warm%20lit%20windows%2C%20cinematic%20urban%20documentary%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-office-03&orientation=landscape",
    date: "2026-09-05",
    reads: 9132,
    status: "多方求证",
    tags: ["物业管理", "公共能耗", "收费透明度"],
    source: "多家入驻企业联合投稿",
    location: "华北地区",
    content: [
      {
        type: "p",
        text: "多位入驻同一栋写字楼的企业负责人投稿称，物业每年下发的「公共能耗分摊」金额持续上涨，但除了一张总额账单外，没有任何可以自行核对的分项说明。租户想查看电表读数、分摊系数，得到的答复多为「内部资料不便提供」。",
      },
      { type: "h2", text: "费用涨幅与明细缺失" },
      {
        type: "p",
        text: "以其中一家中型企业为例，三年前其每月公共能耗分摊约为一千八百元，目前已接近三千元。企业多次要求物业出具分项明细，均未获得书面回复。",
      },
      {
        type: "quote",
        text: "我们不是不愿意交，是希望知道这笔钱到底怎么算出来的，哪怕给我看一次电表也行。",
      },
      {
        type: "list",
        items: [
          "账单仅列总额，缺少电表区间读数与分摊比例。",
          "费用调整未提前书面公示，通常在下一次缴费通知中出现。",
          "部分企业被要求将能耗费用与物业费合并缴纳，无法单独核对。",
        ],
      },
      { type: "h2", text: "当事方回应" },
      {
        type: "p",
        text: "核实小组已向该写字楼物业管理部门发出问询函，询问分摊计算方式与公示安排。截至发稿，物业方表示「正在内部核实，稍后统一回复」。本条目将持续更新。",
      },
    ],
  },
  {
    id: "sc-20260903-04",
    title: "剧组临时换人风波：演员进组三天后被通知「角色调整」",
    category: "entertainment",
    categoryLabel: "明星娱乐",
    excerpt:
      "一名剧组工作人员投稿称，某影视项目在开机后临时更换配角人选，原定演员已完成部分拍摄，双方对解约补偿的说法存在明显出入。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20film%20set%20with%20folded%20director%20chair%20and%20warm%20spotlights%20in%20a%20dim%20studio%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-film-04&orientation=landscape",
    date: "2026-09-03",
    reads: 24680,
    status: "核实中",
    tags: ["影视剧组", "合约", "临时换角"],
    source: "剧组工作人员投稿",
    location: "横店影视城",
    content: [
      {
        type: "p",
        text: "据投稿的剧组工作人员描述，某在拍项目在开机三天后对一名配角做出「角色调整」的处理，原定演员的已拍镜头将被重新拍摄。剧组内部对外的说法是「档期冲突」，但投稿人称实际原因与拍摄进度和成本控制有关。",
      },
      { type: "h2", text: "争议点集中在补偿口径" },
      {
        type: "p",
        text: "投稿人表示，双方对已完成工作时长、往返交通及档期占用的补偿标准各执一词。剧组方面认为按天结算即可，演员方则主张还应包含因临时解约造成的后续档期损失。",
      },
      {
        type: "quote",
        text: "合同里写得很笼统，真到了要算钱的时候，每一句都能有两种解释。",
      },
      {
        type: "p",
        text: "由于涉及具体合约条款与当事人隐私，本文未披露项目名称与演员姓名。核实小组正在向多个独立信源求证开工时间与合同签署节点，本条目暂标注为「核实中」。",
      },
    ],
  },
  {
    id: "sc-20260830-05",
    title: "招聘岗位薪资与实际不符，入职后底薪「腰斩」",
    category: "industry",
    categoryLabel: "行业内幕",
    excerpt:
      "多名求职者投稿称，某公司招聘信息标注的月薪区间在实际入职后被拆分为「底薪 + 绩效 + 全勤」，其中底薪不到标称下限的一半。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20lamp%20lit%20desk%20with%20a%20stack%20of%20signed%20employment%20papers%20and%20a%20pen%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-hr-05&orientation=landscape",
    date: "2026-08-30",
    reads: 17552,
    status: "已核实",
    tags: ["招聘", "薪资结构", "求职避坑"],
    source: "多名求职者投稿",
    location: "多个城市",
    content: [
      {
        type: "p",
        text: "投稿人提供的招聘页面截图显示，该岗位标称月薪为「8000-12000 元」。而实际签署的入职文件中，承担固定发放义务的底薪仅为 3500 元，其余部分被归入绩效与全勤，且绩效发放条件较为模糊。",
      },
      { type: "h2", text: "「区间薪资」的真实构成" },
      {
        type: "list",
        items: [
          "招聘页写区间，入职文件只保障下限以下的固定部分。",
          "绩效与全勤合计占比超过一半，但考核标准未在入职时书面明确。",
          "部分求职者反映，面试时口头承诺的补贴未出现在合同中。",
        ],
      },
      {
        type: "p",
        text: "我们已联系到三位在不同城市入职同一岗位的投稿人，他们对薪资结构的描述基本一致，因此本条目标注为「已核实」。需要说明的是，绩效部分的实际发放情况因团队而异，本页不对个别员工的具体收入作判断。",
      },
      {
        type: "quote",
        text: "面试的时候说得很好听，签合同才发现数字对不上，那时候已经辞了上一份工作。",
      },
    ],
  },
  {
    id: "sc-20260827-06",
    title: "会员自动续费被指「静默扣款」，取消入口藏在三层菜单之后",
    category: "consumer",
    categoryLabel: "消费维权",
    excerpt:
      "读者投稿称，某内容类 App 在免费试用到期前未作显著提醒，直接在次日凌晨完成扣款，而取消续费的入口需要依次进入三个页面才能找到。",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20smartphone%20screen%20glowing%20in%20a%20dark%20room%20with%20warm%20reflections%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-app-06&orientation=landscape",
    date: "2026-08-27",
    reads: 31024,
    status: "已核实",
    tags: ["自动续费", "订阅陷阱", "App 套路"],
    source: "多位读者投稿",
    location: "全国",
    content: [
      {
        type: "p",
        text: "多位读者投稿反映，某内容类 App 的「7 天免费试用」在到期前没有明显的短信或推送提醒，扣款发生在次日凌晨。当他们发现时，订阅已经生效，取消续费需要进入「我的 — 订阅管理 — 自动续费」三层页面才能完成。",
      },
      { type: "h2", text: "扣款时间与提醒方式" },
      {
        type: "p",
        text: "投稿人普遍提到，扣款时间集中在凌晨，而 App 内的提醒多表现为不显眼的站内消息，容易被忽略。这与「试用即将结束」的预期提醒存在差距。",
      },
      {
        type: "quote",
        text: "不是舍不得那点钱，是这种先扣了再说、取消还要翻半天的方式让人很不舒服。",
      },
      { type: "h2", text: "如何自查是否被自动续费" },
      {
        type: "list",
        items: [
          "在应用商店的「订阅管理」中查看所有生效中的自动续费项目。",
          "关闭续费后保留截图，确认显示为「已取消」而非「已申请」。",
          "如已被扣款，尽快在扣款后短时间内联系客服申请退款，成功率更高。",
        ],
      },
      {
        type: "p",
        text: "我们已就提醒方式与取消路径问题向该 App 运营方发出问询，等待其说明。若后续其调整了提醒策略，本页会同步更新。",
      },
    ],
  },
  {
    id: "sc-20260824-07",
    title: "新能源车维修单出现重复计费，「检测服务费」被收了两遍",
    category: "tech",
    categoryLabel: "科技数码",
    excerpt:
      "车主投稿称，售后维修清单中同时出现「故障检测费」与「诊断服务费」两项，金额一致但描述不同，客服未能给出合理解释。",
    cover:
      "https://readdy.ai/api/search-image?query=electric%20car%20charging%20port%20detail%20in%20a%20dim%20service%20garage%20with%20warm%20focused%20light%2C%20cinematic%20automotive%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-car-07&orientation=landscape",
    date: "2026-08-24",
    reads: 14209,
    status: "核实中",
    tags: ["新能源车", "售后维修", "重复收费"],
    source: "车主投稿",
    location: "华南地区",
    content: [
      {
        type: "p",
        text: "投稿车主在一次常规进店检修后拿到维修清单，发现「故障检测费」与「诊断服务费」两项金额完全相同，但项目描述不一致。他向客服询问二者区别，得到的回复是「系统自动生成，属于不同环节」。",
      },
      { type: "h2", text: "清单中的可疑项目" },
      {
        type: "list",
        items: [
          "「故障检测费」与「诊断服务费」并列出现，金额相同。",
          "工时费的计费时长与车主在店等待时长明显不符。",
          "更换的配件未标注品牌与型号，仅有内部编码。",
        ],
      },
      {
        type: "p",
        text: "我们已将清单提交给两位独立汽修从业者比对，他们认为两项费用的描述确有可能指向同一环节。由于涉及具体门店的收费规则，还需向品牌方核实，本条目暂标注为「核实中」。",
      },
      {
        type: "quote",
        text: "如果我不仔细看清单，这笔钱就悄悄收走了，而且我根本不知道自己为什么多付。",
      },
    ],
  },
  {
    id: "sc-20260821-08",
    title: "社区团购「缺斤少两」：标称 500 克净重，实测不足 400 克",
    category: "consumer",
    categoryLabel: "消费维权",
    excerpt:
      "多位读者投稿称，通过社区团购下单的冷冻食品实际重量与标注不符，部分商品连包装一起称重也达不到标称净重。",
    cover:
      "https://readdy.ai/api/search-image?query=kitchen%20scale%20with%20a%20packed%20frozen%20food%20item%20on%20a%20wooden%20counter%20in%20warm%20morning%20light%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-group-08&orientation=landscape",
    date: "2026-08-21",
    reads: 11876,
    status: "已核实",
    tags: ["社区团购", "净含量", "食品安全"],
    source: "多位读者投稿",
    location: "多省",
    content: [
      {
        type: "p",
        text: "多位读者使用厨房秤对社区团购购买的冷冻食品进行了称重。结果显示，标注「净含量 500 克」的商品，去掉包装后实际重量普遍在 380 到 430 克之间，个别样本连包装称重也未达到 500 克。",
      },
      { type: "h2", text: "称重样本与差异区间" },
      {
        type: "p",
        text: "投稿人共提供了 23 组称重照片，涉及三个不同批次的同类商品。其中 19 组的净重低于标称值 10% 以上，已超出常规的计量误差范围。",
      },
      {
        type: "quote",
        text: "一两百克听起来不多，但按标价折算，等于每单都在多收钱。",
      },
      { type: "h2", text: "消费者可以怎么做" },
      {
        type: "list",
        items: [
          "保留商品外包装与标签，拍摄称重过程，注意让秤的读数清晰可见。",
          "在售后申请中明确主张「净含量不足」，而非笼统的「质量问题」。",
          "同一批次问题集中的，可通过市场监管部门渠道集中反映。",
        ],
      },
      {
        type: "p",
        text: "我们已将多个批次的称重记录整理提交给相关平台，平台方回应称「将核查供应商包装与分拣环节」。本页将在收到进一步说明后更新。",
      },
    ],
  },
  {
    id: "sc-20260818-09",
    title: "试用期最后一天被辞退，理由却无法提供书面说明",
    category: "industry",
    categoryLabel: "行业内幕",
    excerpt:
      "投稿人称，公司在试用期届满当天通知其不予转正，给出的口头理由是「不符合岗位要求」，但拒绝出具书面说明与考核记录。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20meeting%20room%20with%20a%20single%20document%20folder%20on%20the%20table%20and%20warm%20window%20light%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-work-09&orientation=landscape",
    date: "2026-08-18",
    reads: 16240,
    status: "多方求证",
    tags: ["试用期", "劳动权益", "书面说明"],
    source: "当事人投稿",
    location: "华中地区",
    content: [
      {
        type: "p",
        text: "投稿人表示，自己在试用期最后一天被通知不予转正。公司口径是「不符合岗位要求」，但既未提供书面的录用条件说明，也未出示任何考核评分记录。他多次索要书面材料，得到的回复是「公司没有这个流程」。",
      },
      { type: "h2", text: "关键争议：录用条件是否事先告知" },
      {
        type: "p",
        text: "按照常见的处理惯例，用人单位主张「不符合录用条件」时，通常需要证明该条件事先已明确告知劳动者，并有相应的考核依据。投稿人称，入职时无人向他说明具体的量化标准，工作内容也多次被临时调整。",
      },
      {
        type: "quote",
        text: "最难受的不是被辞退，是连一个说得清的理由都没有，问了半天只有一句「不合适」。",
      },
      {
        type: "list",
        items: [
          "入职时未收到载明录用条件的书面文件。",
          "考核标准在试用期内被口头调整过两次。",
          "离职时公司拒绝在离职证明中写明具体原因。",
        ],
      },
      {
        type: "p",
        text: "核实小组已向该公司发送问询，询问录用条件的告知方式与考核记录。截至发稿，公司方表示「不便就个案发表意见」。本条目将持续跟进。",
      },
    ],
  },
  {
    id: "sc-20260815-10",
    title: "共享充电宝归还后仍持续计费，客服称「设备未识别」",
    category: "consumer",
    categoryLabel: "消费维权",
    excerpt:
      "多名用户投稿称，明明已将充电宝插入归还槽，App 仍显示「租借中」并继续计费，直到手动申诉后才停止扣款。",
    cover:
      "https://readdy.ai/api/search-image?query=blurred%20row%20of%20shared%20power%20bank%20slots%20glowing%20in%20a%20dim%20convenience%20store%2C%20warm%20city%20light%2C%20cinematic%20documentary%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-power-10&orientation=landscape",
    date: "2026-08-15",
    reads: 9873,
    status: "已核实",
    tags: ["共享充电宝", "计费异常", "申诉"],
    source: "多名用户投稿",
    location: "多个城市",
    content: [
      {
        type: "p",
        text: "投稿用户反映，在归还共享充电宝并确认卡槽指示灯亮起后，App 中仍显示订单「进行中」。计费持续累加，直到用户主动申诉才被停止，部分订单被扣除了远超实际使用时长的费用。",
      },
      { type: "h2", text: "申诉过程中的共性" },
      {
        type: "list",
        items: [
          "归还现场没有打印或发送归还凭证，用户难以自证。",
          "客服多以「设备未识别」为由，要求用户提供归还时的照片。",
          "申诉成功后通常为部分退款，而非全额退回异常扣款。",
        ],
      },
      {
        type: "quote",
        text: "我就在柜机前面站着还的，可它说你没还，那就得你自己找证据。",
      },
      {
        type: "p",
        text: "多家共享充电宝品牌的柜机识别故障并非个例。我们建议归还时拍摄包含柜机编号、卡槽与订单页面的连续画面，作为后续申诉的依据。本页将持续汇总读者的申诉结果。",
      },
    ],
  },
  {
    id: "sc-20260812-11",
    title: "智能门锁固件更新后远程功能受限，用户称未提前告知",
    category: "tech",
    categoryLabel: "科技数码",
    excerpt:
      "数名用户投稿称，门锁在夜间自动完成固件升级后，部分远程开锁与临时密码功能被限制，官方说明中未提及该变化。",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20smart%20door%20lock%20keypad%20glowing%20dimly%20on%20a%20wooden%20door%20with%20warm%20hallway%20light%2C%20cinematic%20product%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-lock-11&orientation=landscape",
    date: "2026-08-12",
    reads: 7441,
    status: "核实中",
    tags: ["智能家居", "固件更新", "功能变更"],
    source: "多名用户投稿",
    location: "多个城市",
    content: [
      {
        type: "p",
        text: "投稿用户称，自家智能门锁在夜间自动下载并安装了新固件，次日发现原本可用的「远程临时密码」功能被限制，需要额外开通某项服务后才能使用。更新说明中并未提及这一变化。",
      },
      { type: "h2", text: "用户关注的核心问题" },
      {
        type: "list",
        items: [
          "固件更新默认自动执行，用户无法选择推迟。",
          "更新日志仅描述性能优化，未说明功能权限的调整。",
          "部分老型号设备在更新后出现耗电加快的情况。",
        ],
      },
      {
        type: "p",
        text: "我们正就更新策略与功能调整的具体范围向厂商求证。由于不同型号的固件版本存在差异，本条目的部分描述可能仅适用于特定批次，特此说明。",
      },
      {
        type: "quote",
        text: "门锁是家里最不能出问题的东西，改功能至少应该说一声。",
      },
    ],
  },
  {
    id: "sc-20260809-12",
    title: "连锁健身房闭店前仍在促销年卡，会员退款通道迟迟未开",
    category: "society",
    categoryLabel: "社会热点",
    excerpt:
      "多家门店会员投稿称，门店在传出闭店消息后仍在推动年卡促销，闭店通知发布后，正式退款通道与时间表均未公布。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20gym%20floor%20at%20dusk%20with%20dumbbell%20racks%20and%20warm%20dim%20light%2C%20cinematic%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=scoop-gym-12&orientation=landscape",
    date: "2026-08-09",
    reads: 21453,
    status: "多方求证",
    tags: ["预付式消费", "健身房", "退款"],
    source: "多家门店会员联合投稿",
    location: "华南地区",
    content: [
      {
        type: "p",
        text: "投稿会员提供的聊天记录显示，闭店消息在会员群中传开前的一段时间，门店销售人员仍在以「即将涨价」为由推动年卡续费。闭店通知发布后，会员被引导至一个登记页面，但正式退款方案与时间表始终未明确。",
      },
      { type: "h2", text: "会员集中反映的问题" },
      {
        type: "list",
        items: [
          "闭店前的促销力度明显高于平时，且强调「名额有限」。",
          "退费登记表只收集信息，不承诺处理时限。",
          "已转让未到期的私教课时，退款口径与合同约定不一致。",
        ],
      },
      {
        type: "quote",
        text: "如果早说要关店，我们肯定不会在最后那两周续费。",
      },
      {
        type: "p",
        text: "我们已联系到同一品牌多家门店的会员，并整理出时间线。由于涉及企业资金与合同履行，仍需向经营方与主管部门求证，本条目暂标注为「多方求证」。",
      },
    ],
  },
];